// User.js

import React from 'react'
import './User.css';

import YunHeader from '../Common/YunHeader/YunHeader';
import YunIcon from '../Common/YunIcon/YunIcon';

import Avatar from './avatar.jpg';
import AvatarActive from './avatar-active.jpg';

import { getVipCheck } from '../../api/em'

import { cppCloseWindow, setWindowTitle, cppSetWindowIcon } from '../../api/cpp';
import { getToken } from '../../utils/auth';
import { openWindow } from '../../utils/index';

import getProductInfo from '../../static/getProductInfo';

import Snackbar from '@material-ui/core/Snackbar';
import { CopyToClipboard } from 'react-copy-to-clipboard';

class User extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            vipInfo: {
                isExpire: true,
                userPhone: '***********',
            },
            productInfo: {},
            open: false
        };
        this.textCopied = this.textCopied.bind(this)
        this.closeSnackbar = this.closeSnackbar.bind(this)
    }

    textCopied(text) {
        this.setState({
            open: true,
        })
    }

    closeSnackbar() {
        this.setState({
            open: false,
        })
    }

    componentDidMount() {
        setWindowTitle('会员');
        getProductInfo().then(productInfo => {
            this.setState({
                productInfo: productInfo,
            })
            cppSetWindowIcon(productInfo.WindowIconFileName);
        })
        getVipCheck().then(res => {
            if (res && res.err === 'ERR_OK' && res.vipInfo) {
                this.setState({
                    vipInfo: res.vipInfo
                })
            }
        })
        // 监听别的页面的通知消息
        try {
            window.onRecvBroadcastWndMsg = (msg) => {
                if (msg === 'Login_In') {
                    // 回到登录页面时，关闭此页面
                    cppCloseWindow()
                }
                // 关闭页面
                if (msg === 'Close_App') {
                    cppCloseWindow()
                }
            }
        } catch (error) {
        }
    }

    render() {
        const handleClose = () => {
            cppCloseWindow()
        }
        const clickGoPayPage = () => {
            // 打开原厂充值页（server/empay），商品来自我们后台
            const base = window.__EM_API_BASE__ || window.location.origin
            openWindow(base + '/empay/?token=' + getToken())
        }
        return (
            <div className="User AppContainer">
                <YunHeader handleClose={handleClose} hideOnTop hideMin productInfo={this.state.productInfo} title="会员"></YunHeader>
                <div className="UserInfo">
                    <img className="Avatar" src={this.state.vipInfo.isExpire ? Avatar : AvatarActive} alt="Avatar" />
                    <div className="UserAccount">
                        <YunIcon icon="user" iconClass={this.state.vipInfo.isExpire ? 'user' : 'user Active'}></YunIcon>
                        <p>{this.state.vipInfo.userPhone || this.state.vipInfo.userWxOpenId}</p>
                        <CopyToClipboard text={this.state.vipInfo.userPhone || this.state.vipInfo.userWxOpenId} onCopy={this.textCopied}>
                            <YunIcon iconClass="Copy" icon="copyIcon"></YunIcon>
                        </CopyToClipboard>
                    </div>
                    <div className="UserVip">
                        <YunIcon icon={ this.state.vipInfo.isExpire ? 'vip' : 'vip-active'} iconClass="vip"></YunIcon>
                        <p>{this.state.vipInfo.isExpire ? '未开通VIP会员' : '至尊VIP会员'}</p>
                    </div>
                    <div onClick={clickGoPayPage} className="PayBtn">{this.state.vipInfo.isExpire ? '开通会员' : '充值续费'}</div>
                </div>
                <div className="VipInfoItem">
                    <div>
                        <YunIcon icon={this.state.vipInfo.isExpire ? 'count' : 'count-active'}></YunIcon>
                        <p>{this.state.vipInfo.isExpire ? '免费使用次数' : 'VIP到期时间'}</p>
                    </div>
                    <span>{this.state.vipInfo.isExpire ? (this.state.vipInfo.tryUseCountToday || 0) + '次' : this.state.vipInfo.vipExpireTime}</span>
                </div>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    open={this.state.open}
                    autoHideDuration={1000}
                    onClose={this.closeSnackbar}
                    message="复制成功"
                />
            </div>
        )
    }
}

export default User;
